import axios from "axios";
import { capitalize } from "lodash";
import { getPathAPI } from ".";

export async function downloadExportFile(
  data: Record<string, any>,
  name?: string
): Promise<void> {
  axios({
    url: `${getPathAPI()}/atlas-files/export?accessToken=${localStorage.getItem(
      "access"
    )}`,
    method: "POST",
    responseType: "blob",
    data
  }).then((response: any) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${name ? name : capitalize(data.type)}.csv`);
    document.body.appendChild(link);
    link.click();
  });
}
